<template>
	<div>
		<div
			v-if="loadFailed"
			class="l-container l-container--full-width l-container--full-width@mobile"
		>
			<EmptyState :text="$I18n.trans('errors.503.message')" />
			<Button
				:text="$I18n.trans('commons.reload')"
				:busy="album.isLoading"
				@click="loadEvents"
			/>
		</div>
		<ViewAlbumEmbedCarousel
			v-else-if="carousel"
			:album="album"
		/>

		<ViewAlbumEmbed
			v-else
			:album="album"
		/>
	</div>
</template>

<script>
import { httpClient } from '@shared/js/api/httpClient';
import { EventFilter } from '@shared/enums/EventFilter';
import Button from '@shared/components/Button';
import EmptyState from '@js/components/EmptyState';
import ViewAlbumEmbedCarousel from './ViewAlbumEmbedCarousel.vue';
import ViewAlbumEmbed from './ViewAlbumEmbed.vue';

export default {
	name:       'ViewDynamicAlbum',
	components: { Button, EmptyState, ViewAlbumEmbedCarousel, ViewAlbumEmbed },
	props:      {
		albumId: {
			type:    Number,
			default: null,
		},
	},
	data: function() {
		return {
			carousel:         true,
			count:            10,
			filters:          null,
			sortOrder:        null,
			invalidUrlParams: false,
			loadFailed:       false,
			album:            {
				events:    [],
				isLoading: true,
			},
		};
	},
	mounted: function() {
		this.applyUrlParams();
		this.loadEvents();
	},
	methods: {
		applyUrlParams() {
			const params = new URLSearchParams(window.location.search);
			const count = Number.parseInt(params.get('count'), 10);
			const defaultCount = this.albumId ? 9 : 10;

			this.carousel = params.has('carousel');
			this.count = Number.isInteger(count) && count > 0 ? count : defaultCount;
			this.filters = this.parseJsonParam(params, 'filters');
			this.sortOrder = this.parseJsonParam(params, 'sortOrder');

			if (this.albumId) {
				this.filters = {
					...(this.filters || {}),
					[EventFilter.ARENA_ALBUM]: this.albumId,
				};
			}
		},
		parseJsonParam(params, key) {
			if (!params.has(key)) {
				return null;
			}

			try {
				const parsedValue = JSON.parse(params.get(key));
				if (!parsedValue || typeof parsedValue !== 'object' || Array.isArray(parsedValue)) {
					this.invalidUrlParams = true;
					return null;
				}

				return parsedValue;
			} catch (_error) {
				// Never turn a malformed filtered embed into an unfiltered public event listing.
				this.invalidUrlParams = true;
				return null;
			}
		},
		async loadEvents() {
			this.album.isLoading = true;
			this.loadFailed = false;

			try {
				if (this.invalidUrlParams) {
					return;
				}

				const opts = {
					page:    1,
					perPage: this.count,
					locale:  window.locale,
				};

				if (this.filters) {
					opts.filters = JSON.stringify(this.filters);
				}
				if (this.sortOrder) {
					opts.sortOrder = JSON.stringify(this.sortOrder);
				}
				const response = await httpClient.getDynamicAlbumEvents(opts);
				if (response.status !== 200 || !Array.isArray(response.data?.data)) {
					// An invalid success response is an outage, not proof that the album is empty.
					throw new Error('Dynamic album events response is malformed');
				}

				this.album = {
					events: response.data.data,
				};
			} catch (_error) {
				this.loadFailed = true;
			} finally {
				this.album.isLoading = false;
				this.$nextTick(() => {
					if (typeof window.sendHeightToParent === 'function') {
						window.sendHeightToParent();
					}
				});
			}
		},
	},
};
</script>

<style>

</style>
